// Types
import Alt from '@/types/models/alt';
import Dictionary from '@/types/dictionary';
import Disclaimer from '@/types/disclaimer';
import Locale from '@/types/locale';

// Utils
import helpers from './helpers';
import { DISCLAIMER_KEYS, DISCLAIMER_TAG } from './constants';
import { formatMessage, generateLocalizedString } from '@/utils/i18n';

/**
 * Build the disclaimers to be implemented inside an alternative investment response.
 * @param alt Alt used to generate the disclaimers.
 * @param locale Locale to be used.
 */
export const updateAltWithDisclaimers = (alt: Alt, locale: Locale): Alt => {
  const name = alt.names?.full?.[locale] ?? '';
  const manufacturer = alt.manufacturer ? `${alt.manufacturer} ${formatMessage('Disclaimers.AltCustomDisclaimer.Or')}` : '';
  const content = generateLocalizedString('Disclaimers.AltCustomDisclaimer.Full', { name, manufacturer });
  const tags = [DISCLAIMER_TAG.COMPARISON, DISCLAIMER_TAG.PROPOSAL];
  return { ...alt, disclaimers: [{ content, tags }] };
};

/**
 * Generates the disclaimers to be used inside a comparison for an alternative investment.
 * @param alt Alt used to generate the disclaimers.
 */
export const getComparisonAltDisclaimers = (alt: Alt) => {
  const disclaimers: Dictionary<Disclaimer> = {};
  const altDisclaimers = helpers.getAltDisclaimers(alt);

  if (altDisclaimers.length > 0) {
    disclaimers[DISCLAIMER_KEYS.INSTRUMENT_CUSTOM_DISCLAIMER] = {
      key: DISCLAIMER_KEYS.INSTRUMENT_CUSTOM_DISCLAIMER,
      data: {
        holdings: altDisclaimers,
      },
    };
  }

  return disclaimers;
};
